/*
 * @Description: 计费规则接口
 * @Author: huzhibo
 * @Email: hzbfun@gmail.com
 * @Date: 2020/11/13 15:12
 */
import http from "e6-base-core/axios/config";
import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_FINANCIAL_WEB = ""
} = e6ModuleSettleAccountsCenterApi;

// 获取计费规则详情
export function getFeeSettingDetail(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractRule/detail`,
    method: "get",
    params
  });
}

// 查看条件接口
export function getConditionDefineList(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractRule/listConditionDefine`,
    method: "get",
    params
  });
}

// 查看比较运算接口
export function getFeeRuleOperateList(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractRule/listOperator`,
    method: "get",
    params
  });
}

// 保存
export function saveContractRules(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractRule/save`,
    method: "post",
    data
  });
}

// 电子路书简单版导入
export function importFreightRoadBook(data) {
  return http({
    headers: { "Content-Type": "multipart/form-data;" },
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractRule/importFreightRoadBook`,
    method: "post",
    data
  });
}

// 收发货地简单版导入
export function importFreightSendAndReceiveArea(data) {
  return http({
    headers: { "Content-Type": "multipart/form-data;" },
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractRule/importFreightSendAndReceiveArea`,
    method: "post",
    data
  });
}
